import React from 'react';
import PropTypes from 'prop-types';

import { withLocale } from '../LocaleProvider';

export class ButtonBase extends React.PureComponent {
  resolveHref = value => {
    if (!value) return '';
    if (typeof value === 'string') return value;

    // Contentful/route objects sometimes come through instead of plain URLs.
    // Normalize them to a usable href to avoid '/[object Object]' navigation.
    if (typeof value === 'object') {
      if (typeof value.href === 'string') return value.href;
      if (typeof value.url === 'string') return value.url;
      if (typeof value.link === 'string') return value.link;
      if (typeof value.path === 'string') return value.path;
      if (typeof value.slug === 'string') return value.slug;
      if (typeof value.pathname === 'string') {
        const query = value.query && typeof value.query === 'object'
          ? new URLSearchParams(value.query).toString()
          : '';
        return query ? `${value.pathname}?${query}` : value.pathname;
      }
    }

    return '';
  };

  render() {
    const {
      children,
      className,
      handler,
      type,
      href,
      to,
      locale,
      onClick,
      ...other
    } = this.props;
    const { target } = this.props;
    const resolvedTo = this.resolveHref(to);
    const resolvedHref = this.resolveHref(href);
    let Tag = '';
    let compProps = {};
    if (target === '_blank') {
      Tag = 'a';
      compProps.href = resolvedHref || resolvedTo;
    } else if (resolvedTo) {
      Tag = 'a';
      compProps.href = resolvedTo;
    } else if (resolvedHref) {
      Tag = 'a';
      compProps.href = resolvedHref;
    } else {
      Tag = 'button';
      compProps.type = type || 'button';
    }

    // Support both 'handler' and 'onClick' props for backward compatibility
    const onClickHandler = handler || onClick;

    return (
      <Tag
        className={className}
        target={target}
        onClick={onClickHandler}
        {...other}
        {...compProps}
      >
        {children}
      </Tag>
    );
  }
}

ButtonBase.propTypes = {
  className: PropTypes.string.isRequired,
  type: PropTypes.string,
  handler: PropTypes.func,
  children: PropTypes.node.isRequired,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const ButtonBase = ({prop = val, type = 'button', handler = () => null, to = '' }) =>

export default withLocale(ButtonBase);
